import { useEffect } from "react";

function Layout(props) {

    const { children, opened, onClose } = props;

     // Bloque le scroll du body quand ouvert
     useEffect(() => {
        if (opened) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = '';
        }
        return () => {
            document.body.style.overflow = '';
        };
    }, [opened]);

    return (
        opened
        ? <div 
            className="screensize flex" 
            style={{
                position: "fixed",
                top: 0,
                left: 0,
                width: "100vw",
                height: "100vh",
                overflowY: "auto",
                overflowX: "hidden",
                boxSizing: "border-box",
                padding: "2vmax",
                zIndex: 1000,           // 👈 passe au-dessus de tout
                justifyContent: "flex-start",
                backgroundColor: "#fff" // 👈 couvre le contenu en dessous
            }}
        >
            
            <div className="flex flexdot8">{children}</div>
            <br />
            <div className="flex flexdot1">
                <button className="app-button xlarge" onClick={() => onClose()}>Fermer</button>
            </div>
        </div>
        : null
    )

}

export default Layout;